<template>
  <div>
    <el-card>
      <edit-form
        :disabled="isDisableEditForm"
        :roleID="params.roleID"
        ref="editForm"
      />
      <div class="mt-2">
        <el-row>
          <el-col :span="20">
            <el-button
              v-if="!isDisableEditForm"
              size="mini"
              type="primary"
              @click="save()"
            >
              {{ $l('INDEX.btn_save') || '保存' }}
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-card>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
export default {
  name: 'system-role-detail',
  components: {
    EditForm,
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    pageHeader() {
      const types = {
        add: this.$l('form_label_add_role_permission') || '添加角色权限信息',
        edit: this.$l('form_label_edit_role_permission') || '编辑角色权限信息',
        detail:
          this.$l('form_label_role_role_permission') || '角色权限信息详情',
      }
      return types[this.pageType]
    },
    isDisableEditForm() {
      return this.pageType === 'detail'
    },
  },
  methods: {
    save() {
      this.$refs.editForm.save()
    },
  },
}
</script>
